<template>
  <div id="sidebar-wrapper" class="d-flex flex-column h-100" :class="{'toggled': showLeftbar}"  v-if="user">
    <div class="logo-wrapper text-center pt-2 pb-2">
      <router-link :to="{ name: 'Overview' }"><img src="/img/logo.png" alt /></router-link>
    </div>

    <router-link :to="{ name: 'Profile', params: { profileId: user.id }}" @click.native="hideLeftbar">
    <div class="sidebar-header">      
      <div class="user-info">
        <div class="user-pic">
          <img class="img-responsive img-rounded" :src="profileImage" alt="User picture">
        </div>
        <span class="user-name">
          <i class="fas fa-circle online"></i> {{ user.name }}
        </span>        
        <span class="user-role">{{ user.team.name }}</span>
        <span class="user-role">{{ user.email }}</span>
      </div>
    </div>
    </router-link>

    <ul class="sidebar-nav">
      <li @click="hideLeftbar">

        <router-link :to="{ name: 'Overview' }" class="nav-link">
           <i class="fal fa-home nav-icon" />          
          {{ $t('LEFTBAR.DASHBOARD') }}
          </router-link>
      </li>

      <li @click="hideLeftbar">
        <router-link :to="{ name: 'Documents' }" class="nav-link">
          <i class="fal fa-folder nav-icon" />   
          {{ $t('LEFTBAR.DOCUMENTS') }}
          </router-link>
      </li>

      <li @click="hideLeftbar">
        <router-link :to="{ name: 'Services' }" class="nav-link">
          <i class="fal fa-cubes nav-icon" />  
          {{ $t('LEFTBAR.SERVICES') }}
          </router-link>
      </li>

      <li @click="hideLeftbar" v-if="user.isAdmin == 1">
        <router-link :to="{ name: 'Team' }" class="nav-link">
          <i class="fal fa-users nav-icon" />    
          {{ $t('LEFTBAR.TEAM') }}
          </router-link>
      </li>

       <li @click="hideLeftbar">
        <router-link :to="{ name: 'Templates' }" class="nav-link">
          <i class="fal fa-file-invoice nav-icon" />    
          {{ $t('LEFTBAR.TEMPLATES') }}
          </router-link>
      </li>

      <li @click="hideLeftbar">
        <a href="#" @click="logoutAction" class="nav-link">
          <i class="fal fa-sign-out-alt  nav-icon" />    
          {{ $t('LEFTBAR.LOGOUT') }}
          </a>
      </li>
    </ul>

    <footer class="footer mt-auto py-3">
        <div class="container text-center">

          <LocaleLogin class="mb-2 ml-2"></LocaleLogin>

            <small> DCP Net AB &copy; 2019</small>
        </div>
    </footer>

  </div>
</template>

<script>
import LocaleLogin from "./LocaleLogin";
export default {
  components: {
    LocaleLogin
  },
  data() {
    return {
      profileImage: this.$store.state.auth.profileImage,
      user: this.$store.state.auth.user
    };
  },
  methods: {
    hideLeftbar() {
      this.$store.dispatch("sidebar/hideLeft");
    },
    logoutAction() {
      let self = this;
      this.$http
        .get(process.env.VUE_APP_BACKEND + `/auth/logout`)
        .finally(function() {
          self.$router.push({ name: "Login" });
        });
    }
  },
  computed: {
    showLeftbar() {
      return this.$store.state.sidebar.leftbar;
    }
  },
  created: function() {}
};
</script>
<style>
</style>
